import { create } from 'zustand';

interface InactivityTimeoutState {
  // Warning modal state
  isWarningVisible: boolean;
  secondsRemaining: number;

  // Actions
  setWarningVisible: (visible: boolean) => void;
  setSecondsRemaining: (seconds: number) => void;
  resetWarning: () => void;
}

export const useInactivityTimeoutStore = create<InactivityTimeoutState>()((set) => ({
  // Initial state
  isWarningVisible: false,
  secondsRemaining: 60,

  // Actions
  setWarningVisible: (visible) =>
    set({
      isWarningVisible: visible,
    }),

  setSecondsRemaining: (seconds) =>
    set({
      secondsRemaining: seconds,
    }),

  resetWarning: () =>
    set({
      isWarningVisible: false,
      secondsRemaining: 60,
    }),
}));
